import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* @media (min-width: 700px) {
    background-color: red;
  } */
`;

export const SubContainer = styled.div`
  width: 340px;
  height: ${(props) => props.heigth};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const Title = styled.p`
  color: ${(props) => props.color};
  font-family: "Inter";
  font-size: ${(props) => props.fontSize};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
`;

export const Form = styled.form`
  height: 370px;
  width: 100%;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-color: #212529;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-top: 10px;
`;
export const Label = styled.label`
  color: white;
  font-family: "Inter";
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  padding-left: 10px;
`;
